import Cache from 'root/cache';
import $ from 'jquery';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'survey-schedule-form',

    events: {
        'change input[name="active_type"]'  : 'onChangeActivate',
        'change .date-end input'            : 'onChangeEndDate',
        'click .account-upgrade'            : 'onAccountUpgrade'
    },

    dom_handlers: {
        onChangeActivate: function(e) {
            this.$el.find('.date-end').toggleClass('active', $(e.currentTarget).val() === 'schedule');

            if ($(e.currentTarget).val() === 'schedule') {
                // set default value
                var now_date_str = Util.moment(Util.now().unix() + 86400, 'YYYY-MM-DD', false, false);
                var now_time_str = Util.moment(Util.now().unix(), 'HH:mm', false, false);
                this.$el.find('.date-end input[type="date"]').val(now_date_str);
                this.$el.find('.date-end input[type="time"]').val(now_time_str);

                // set min date
                this.$el.find('.date-end input[type="date"]').attr('min', now_date_str);
                this.updateInstruction();
            } else {
                this.$el.find('.schedule-instruction').empty();
            }
        },
        onChangeEndDate: function(e) {
            this.updateSettings();
            this.updateInstruction();
        },
        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    updateInstruction: function() {
        var now_date_str = this.$el.find('.date-end input[type="date"]').val();
        var now_time_str = this.$el.find('.date-end input[type="time"]').val();
        var timeStamp = Util.dateStringToTimestamp(`${now_date_str} ${now_time_str}`, 'YYYY-MM-DD HH:mm');
        this.$el.find('.schedule-instruction').text('It will be deactiated on ' + Util.moment(timeStamp, 'DD MMM YYYY h:mm a', false, false));
    },

    updateSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    getSettings: function() {
        var settings = {
            is_active: false,
            end_time: 0,
            start_time: 0
        };

        // if schedule is selected
        if (this.$el.find('#schedule').prop('checked')) {
            var s_date_str = this.$el.find('.date-end input[type="date"]').val();
            var s_time_str = this.$el.find('.date-end input[type="time"]').val();

            settings.is_active = true;
            settings.end_time = Util.dateStringToTimestamp(`${s_date_str} ${s_time_str}`, 'YYYY-MM-DD HH:mm');
        }

        return settings;
    },

    getData: function() {
        return this.getSettings();
    },

    render: function() {
        var content =
        '<div>' +
            '<p>' +
                'Once deactivated, it will not be available to collect responses. You can activate it again at any time.' +
            '</p>' +
            '<div>' +
                '<input id="deactivate" type="radio" name="active_type" value="deactivate" checked><label for="deactivate">Deactivate now</label>' +
            '</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<input id="schedule" type="radio" name="active_type" value="schedule"><label for="schedule">Schedule for later</label>' +
                (Cache.account.hasFeature('survey_schedule') ? '' : '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
            '</div>' +
            '<div class="date-end">' +
                '<input type="date" name="survey_end_date" class="solid compact">' +
                '<input type="time" name="end_time" class="solid compact">' +
            '</div>' +
            '<div class="schedule-instruction"></div>' +
        '</div>'

        this.$el.html(content);

        // feature check
        if (!Cache.account.hasFeature('survey_schedule')) {
            this.$el.find('#schedule').prop('disabled', true);

            if (this.model.get('end_time')) {
                // when there is time set already, preload the data
                this.$el.find('#schedule').prop('checked', true);
                this.$el.find('.date-end').toggleClass('active', true);
    
                var end_date_str = Util.moment(this.model.get('end_time'), 'YYYY-MM-DD', false, false);
                var end_time_str = Util.moment(this.model.get('end_time'), 'HH:mm', false, false);
                this.$el.find('.date-end input[type="date"]').val(end_date_str);
                this.$el.find('.date-end input[type="time"]').val(end_time_str);
            } else {
                this.$el.find('#deactivate').prop('checked', true);
            }
        } else {
            this.$el.find('#deactivate').prop('checked', true);
        }

        return this;
    }
});
